module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAbCAMAAADF2xaWAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJHRSTlMAfZztP+b0icKS19EcFu/JjoVXRze4TdWAbFEO29ild3NgRjangsuAAAAAxklEQVQoz9WS2Q7CIBBFqXQQoWoXu9i6e///GxVKSo2lTXzzvJBLTmZgMmzMVnNDnbAQMXqKoHFwRrxs/NDFv5QEBOmEzbDGhs3TYO1DqMafGFc0U4PKVgMatQ+ZG11HCME7a1SgaEBi7wMht0YOyQZuiHwocbdni33gL9LVKMZGhnRstO4dAcPVWCmCUDq235aKgyu5NeGplQCpC0NPOt6xhwmRC0zAEn3t6REWsWxMdik+upT8zY4qc5mcdyacEquTCbx8ATjIHaNOpW6TAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/icon2.png
// module id = 8FPX
// module chunks = 1